import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import find from 'lodash/find';
import { ReactComponent as FeedbackIcon } from '../../design-system/design_system/assets/icons/system/feedback.svg';
import FeedbackRatingAEM from './FeedbackRatingAEM';
import ChatAEM from './ChatAEM';

const FeedbackAEM = (props) => {
  const [feedback, setFeedback] = useState(false);
  const {
    onlineButtonId, offlineButtonId, reactiveButtonId, feedbackContent, footerType,
  } = props;

  const closeFeedBack = (value) => {
    setFeedback(value);
  };
  const items = get(feedbackContent, ':items.root.:items');
  const feedbackClickToChat = find(items, { componentname: 'feedback' });
  const enableFeedback = useSelector(state => state.DashboardAEMReducer.DashboardAEMContent?.enableFeedback);
  return (
    <React.Fragment>
      <div data-testid="feedback-comp" className={cx({ 'd-md-block': !(footerType === 'search' || footerType === 'RDsearch') }, 'd-none d-print-none')}>
        <ChatAEM onlineButtonId={onlineButtonId} offlineButtonId={offlineButtonId} reactiveButtonId={reactiveButtonId} />
        {(!feedback) && enableFeedback !== "hide" && (
        <section className="feedback-container shadow-2">
          {/* { console.log('feedback', feedback)} */}
          <Button data-testid="close-feedback" variant="ghost" className="border-0 feedback-icon bg-white" onClick={() => setFeedback(!feedback)} aria-label={get(feedbackClickToChat,'feedbackLabel')}>
            <FeedbackIcon className="agent-icon svg-fill-primary" />
            <span className="feedback p-2">{get(feedbackClickToChat, 'feedbackLabel')}</span>
          </Button>
        </section>
        )}
      </div>
      {feedback && (
        <FeedbackRatingAEM closeFeedBack={closeFeedBack} />
      )}
    </React.Fragment>
  );
};

FeedbackAEM.propTypes = {
  onlineButtonId: PropTypes.string,
  offlineButtonId: PropTypes.string,
  reactiveButtonId: PropTypes.string,
  footerType: PropTypes.string.isRequired,
  feedbackContent: PropTypes.instanceOf(Object).isRequired,
};

FeedbackAEM.defaultProps = {
  reactiveButtonId: '',
  offlineButtonId: '',
  onlineButtonId: '',
};


const mapStateToProps = state => ({
  feedbackContent: state.CommonReducer.feedbackContent,
});

export default connect(
  mapStateToProps,
  null,
)(FeedbackAEM);
